import { NgModule } from '@angular/core';
import {
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbTreeGridModule,
  NbDialogModule,
  NbButtonModule,
  NbSelectModule,
  NbCheckboxModule,
  NbWindowModule,
  NbRadioModule,
  NbTabsetModule,
  NbTooltipModule,
  NbAccordionModule,
  NbListModule,
  NbProgressBarModule,
  NbToggleModule,
  NbPopoverModule,
  NbUserModule,
  NbSpinnerModule,
  NbContextMenuModule,
} from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { AdminRoutingModule, routedComponents } from './admin-routing.module';
import { UserDialogComponent } from './user/show/user-dialog.component';
import { UserComponent } from './user/user.component';
import { NgxSelectModule, INgxSelectOptions } from 'ngx-select-ex';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmOperationComponent } from '../../@theme/components/confirm-operation/confirm-operation.component';
import { ImportFileComponent } from '../../@theme/components/import-file/import-file.component';
import { PickListModule } from 'primeng/picklist';
import { ResultDTOService } from '../../@core/utils/result-dto.service';
import { ColumnRenderStatusComponent } from './result-import/column-render-status.component';
import { ShowDepartamentComponent } from './departament/show/show-departament.component';
import { ShowTypeTemplateComponent } from './type-template/show/show-type-template.component';
import { ShowOrganizationUnitComponent } from './organization-unit/show/show-organization-unit.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ShowGuidelineComponent } from './guideline/show/show-guideline.component';
import { ShowPeriodComponent } from './period/show/show-period.component';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { ptBrLocale } from 'ngx-bootstrap/locale';

defineLocale('pt-br', ptBrLocale);

import { UserActivationComponent } from './user/user-activation/user-activation.component';

import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ShowInternalSearchComponent } from './internal-search/show/show-internal-search.component';
import { MyCustomComponent } from './internal-search/custom-action.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { DashboardDetailComponent } from './internal-search/dashboard/detail/dashboard-detail.component';
import { TabsModule } from "ngx-tabs";
import { MyAccountComponent } from './my-account/my-account.component';

import { ChartsModule } from 'ng2-charts';
import { AddQuestionComponent } from '../../@theme/components/add-question/add-question.component';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgbDropdownModule, NgbProgressbarModule, NgbRatingModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CardHelpCenterArticleComponent } from '../../@theme/components/card-help-center-article/card-help-center-article.component';
import { QuillModule } from 'ngx-quill';
import { TagCloudModule } from 'angular-tag-cloud-module';
import { ShowEHSMicroIndicadorComponent } from './employee-health-score/show/show-ehs-micro-indicador.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { CustomMenuComponent } from './internal-search/custom-action-menu.component';
import { ShowHelpCenterArticleComponent } from './help-center-article/show/show-help-center-article.component';
import { ShowHelpCenterCategoryComponent } from './help-center-category/show/show-help-center-category.component';
import { MyCustomImportEHSComponent } from './employee-health-score/custom-action-ehs-import';
import { ColumnStatusPeriodComponent } from './period/column-status-period.component';
import { ColumnBooleanPeriodComponent } from './period/column-boolean.component';
import { NgxViacepModule } from '@brunoc/ngx-viacep';
import { NgxMaskModule } from 'ngx-mask';
import { ShowTypeHiringUserComponent } from './type-hiring-user/show/show-type-hiring-user.component';
import { MultiSelectComponent } from '../../@theme/components/multi-select/multi-select.component';
import { SingleSelectComponent } from '../../@theme/components/single-select/single-select.component';
import { CardUserFeedbackComponent } from '../../@theme/components/card-user-feedback/card-user-feedback.component';
import { ShowModalityWorkuserComponent } from './modality-work-user/show/show-modality-work-user.component';
import { ImportUserEmailComponent } from '../../@theme/components/import-user-email/import-user-email.component';


const CustomSelectOptions: INgxSelectOptions = {
  optionValueField: 'codeIndex',
  optionTextField: 'description',
  keepSelectedItems: false,
};

@NgModule({
  imports: [
    NbCardModule,
    NbTreeGridModule,
    NbIconModule,
    NbTooltipModule,
    NbInputModule,
    NbSelectModule,
    ReactiveFormsModule,
    ThemeModule,
    NbButtonModule,
    AdminRoutingModule,
    Ng2SmartTableModule,
    NbAccordionModule,
    NbCheckboxModule,
    NbDialogModule.forChild(),
    NbWindowModule.forChild(),
    NgxSelectModule.forRoot(CustomSelectOptions),
    FormsModule,
    PickListModule,
    NbRadioModule,
    NbTabsetModule,
    NgMultiSelectDropDownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    NbListModule,
    NbProgressBarModule,
    ChartsModule,
    NbRadioModule,
    NbPopoverModule,
    NbUserModule,
    QuillModule.forRoot(),
    NgxEchartsModule,
    TabsModule,
    NbToggleModule,
    TableModule,
    InfiniteScrollModule,
    NgbProgressbarModule,
    NgbRatingModule,
    TagCloudModule,
    NbSpinnerModule,
    DropdownModule,
    InputNumberModule,
    InputTextModule,
    NbTabsetModule,
    NgbTooltipModule,
    NgbDropdownModule,
    NgxViacepModule,
    NgxMaskModule,
    NbContextMenuModule,
  ],

  declarations: [
    ...routedComponents,
  ],
  providers: [
    ResultDTOService
  ],
  entryComponents: [UserComponent, UserDialogComponent, MyAccountComponent,
    UserActivationComponent,
    ConfirmOperationComponent, ShowInternalSearchComponent,
    ImportFileComponent, ImportUserEmailComponent, ColumnRenderStatusComponent, ShowDepartamentComponent,
    ShowTypeTemplateComponent, ShowTypeHiringUserComponent, ShowModalityWorkuserComponent, MyCustomComponent, ShowOrganizationUnitComponent,
    ShowHelpCenterCategoryComponent, ShowHelpCenterArticleComponent, CardHelpCenterArticleComponent, ShowGuidelineComponent,
    ShowPeriodComponent, AddQuestionComponent, CustomMenuComponent, ShowEHSMicroIndicadorComponent, MyCustomImportEHSComponent,
    ColumnStatusPeriodComponent, ColumnBooleanPeriodComponent, SingleSelectComponent, MultiSelectComponent, CardUserFeedbackComponent]
})
export class AdminModule {
}
